import { SiteNav } from '../components/layout/SiteNav';

/**
 * PageLayout — standard inner-page shell with sticky nav and scrollable main.
 */
export function PageLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-bg)]">
      <SiteNav />
      <main className="flex-1 w-full max-w-5xl mx-auto px-4 sm:px-6 py-10 lg:py-14">
        {children}
      </main>
      <footer className="border-t border-white/[0.05] py-6 px-4 sm:px-6 text-center">
        <p className="text-xs text-[var(--color-muted)]">
          © {new Date().getFullYear()} Simone Carani
        </p>
      </footer>
    </div>
  );
}
